package link.erpango.quip.utils

import kotlinx.serialization.Serializable

@Serializable
data class FileData(
    val fileName: String,
    val fileContentBase64: String,
    val mimeType: String
)
